import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../assets/Icon';
import { ISweepRoomItem } from '../../store/sweeps/types';
import { Container, DataTemplate, RoomItemStatIcon, RoomItemStats, RoomItemName, RoomItemStat } from './styles';

interface Props {
    item: ISweepRoomItem;
}

const RoomItemItem: React.FC<Props> = ({ item }) => {
    const { t } = useTranslation();

    return <Container>
        <DataTemplate>
            <RoomItemName>
                {item.name}
            </RoomItemName>

            <RoomItemStats>
                <RoomItemStat>
                    <RoomItemStatIcon><Icon size={20} icon={'number'} color={'#FFF'} /></RoomItemStatIcon>
                    {item.amount || '--'}
                </RoomItemStat>

                <RoomItemStat>
                    <RoomItemStatIcon><Icon size={20} icon={'warning'} color={'#FFF'} /></RoomItemStatIcon>
                    {item.risk === 2 ? t("pages.items.high") : item.risk === 1 ? t("pages.items.medium") : t("pages.items.low")}
                </RoomItemStat>
            </RoomItemStats>
        </DataTemplate>
    </Container>
}

export default RoomItemItem;